import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { ItemType } from 'app/common/ui-next/plain-selector'
import { CustomerType } from 'app/dataTypes/reports/customersType'

export type CustomerTypeData = Array<ItemType>

class CustomerTypeFilterDataBox extends DataBox<CustomerTypeData> {}

export const defaultCustomerType: CustomerTypeData = []
export const customerTypeFilter = createDataBox(
  'customerTypeFilter',
  defaultCustomerType,
  CustomerTypeFilterDataBox,
)

export const defaultCustomerTypeData = () => {
  return [{ id: CustomerType.Students, title: 'Учащиеся' }]
}

export const defaultCustomerTypeSelection: Array<string> = ['0'] // ?
export const customerTypeFilterSelection = createDataBoxDefault<Array<string>>(
  'customerTypeFilterSelection',
  defaultCustomerTypeSelection,
)
